module.exports = __webpack_public_path__ + "static/img/rank_41.41fd782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_41.png
// module id = /xQw
// module chunks = 1